import { useEffect } from "react";
import { useAuth } from "./AuthContext";
import { useLanguage, EXPLICIT_KEY } from "./LanguageContext";

// Mounted inside LanguageProvider (which is inside AuthProvider).
// Whenever the authenticated user changes, sync their preferred language
// from the user doc into the LanguageContext. Prefers `language` (new
// field written by PATCH /users/me) and falls back to the legacy
// `preferred_language` field for back-compat.
//
// Exception: if the user picked a language THEMSELVES in this session — the
// pre-login flag picker is the whole point of that — their choice wins and is
// written to the account instead. Without this, someone who reads neither
// English nor Portuguese picks Español on the login screen and is dumped back
// into English the instant they sign in, which is the exact trap the picker
// exists to prevent.
export default function LanguageSyncer() {
  const { user } = useAuth();
  const { setLanguage, language } = useLanguage();

  useEffect(() => {
    if (!user) return;

    let explicit = null;
    try {
      explicit = sessionStorage.getItem(EXPLICIT_KEY);
    } catch (_) {}

    if (explicit) {
      // One-shot: clear first so the PATCH below (which updates user.language
      // and re-runs this effect) falls through to the normal restore path.
      try {
        sessionStorage.removeItem(EXPLICIT_KEY);
      } catch (_) {}
      if (explicit !== (user.language || user.preferred_language)) {
        setLanguage(explicit); // persists to the account
      }
      return;
    }

    const preferred = user.language || user.preferred_language;
    if (preferred && preferred !== language) {
      setLanguage(preferred, { explicit: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, user?.language, user?.preferred_language]);

  return null;
}
